import { render, staticRenderFns } from "./IDCard.vue?vue&type=template&id=7fcdd870&scoped=true"
import script from "./IDCard.vue?vue&type=script&lang=js"
export * from "./IDCard.vue?vue&type=script&lang=js"
import style0 from "./IDCard.vue?vue&type=style&index=0&id=7fcdd870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcdd870",
  null
  
)

export default component.exports